import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=5392ca06"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=5392ca06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports